<template>
  <main class="project-page page-padding page-sidebar">
    <transition name="fade">
      <div v-if="project"
           class="project-body"
           :class="{'project-body_open': navigatorOpen, 'fullscreen-body': !activeZoom}">
        <projects-navigator :class="{'zoomed-navigator': activeZoom}"></projects-navigator>
        <project-tree v-if="!routeItem"></project-tree>
        <router-view v-else></router-view>
      </div>
    </transition>
    <transition name="form-right">
      <project-info v-if="project"></project-info>
    </transition>

    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import {projectPageMixin} from "../../mixins/projects/projectPageMixin";

  export default {
    name: 'projectPage',
    mixins: [projectPageMixin],
    watch: {
      routeItem(val) {
        if (val == undefined) {
          this.setIsProjectItem(false);
          this.checkFullScreen();
          this.setRouteName(this.project.name);
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const param = vm.$route.params.id;

        vm.setIsProjectItem(false);

        vm.showLoader();
        await vm.getUsers();
        await vm.getInvitedUsers();

        if (vm.isItemProjects) {
          await vm.getProjectItem(param);
        } else {
          await vm.getProject(param);
        }
        vm.setFullSidebar(false);
        vm.setLinkName('projects');
        vm.setRouteName(vm.projectMother.name);
        vm.getOwnedRoles();
        document.title = `OmniIoTh | Проект ${vm.projectMother.name}`
        vm.hideLoader()
      })
    }
  }
</script>

<style lang="scss" scoped>
.project-page {
  padding-bottom: 30px;
  display: flex;
}

  .project-body {
    width: 100%;
    padding-left: 70px;
    position: relative;
    background: $lightGrey;
  }

  .fullscreen-body {
    background: none;
  }

  .project-body_open {
    padding-left: 300px;

    @media screen and (max-width: 1500px) {
      padding-left: 250px;
    }

    @media screen and (max-width: 1370px) {
      padding-left: 200px;
    }
  }

</style>
